import addresses from "./addresses";

export default addresses;
